import {Route} from '@angular/router';
import {AuthGuard} from '../../auth/guards/auth.guard';

export const homeRoute: Route = {
    path: '',
    canLoad: [AuthGuard],
    loadChildren: () => import('./home.module').then(m => m.HomeModule),
};